import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20living%20room%20scene%20with%20multiple%20cute%20cats%20of%20different%20breeds%20playing%20and%20resting%20on%20a%20soft%20cream%20colored%20sofa%20warm%20natural%20sunlight%20streaming%20through%20windows%20dreamy%20soft%20focus%20atmosphere%20warm%20peach%20and%20cream%20color%20palette%20editorial%20lifestyle%20photography%20with%20artistic%20composition%20peaceful%20and%20heartwarming%20vibe&width=1600&height=900&seq=hero-cat-bg&orientation=landscape"
        alt="猫咪视频大全 - 最萌最治愈的猫咪视频合集"
        title="猫咪视频大全 - 最萌最治愈的猫咪视频合集"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-sm font-medium mb-6">
          每日更新精选猫咪视频
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight text-balance">
          猫咪视频大全
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚全网最热门、最治愈的猫咪视频，涵盖<strong>搞笑猫咪视频</strong>、<strong>可爱猫咪日常</strong>、<strong>萌猫短片</strong>等精选内容。无论你是资深猫奴还是新手铲屎官，这里的猫咪视频都能让你瞬间解压、治愈心灵。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/gaoxiao"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/zhiyu"
            className="px-8 py-3 rounded-full bg-white/20 text-white font-medium text-sm hover:bg-white/30 transition-all duration-200 backdrop-blur-sm whitespace-nowrap"
          >
            治愈一下
          </Link>
        </div>
      </div>
    </section>
  );
}